import { createContext } from 'react';

import useCommonState from './useCommonState';

type Context = ReturnType<typeof useCommonState>;

const CommonStateContext = createContext<Context>({} as any);

export default CommonStateContext;
